// @ts-expect-error FIXME: REPAIR UPGRADE TO NEWER VERSION
import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

const NOTIFICATIONS_SELECT_EMPTY_SPACE = 40;

export const NotificationsWrapper = styled.div(
    ({ theme: { boxShadow, palette, radius } }) => css`
        background: ${palette.neutral.white};
        border-radius: ${radius[8]}px;
        box-shadow: ${boxShadow.big};
        padding-top: 24px;
        position: absolute;
        right: -24px;
        top: calc(100% + 8px);
        width: 456px;
    `,
);

export const MobileNotificationsWrapper = styled(motion.div)(
    ({ theme: { boxShadow, palette } }) => css`
        background-color: ${palette.neutral.white};
        box-shadow: ${boxShadow.small};
        display: flex;
        flex-direction: column;
        height: 100vh;
        left: 0;
        padding-top: 70px;
        position: fixed;
        top: 0;
        width: calc(100vw - ${NOTIFICATIONS_SELECT_EMPTY_SPACE}px);
        z-index: 99;
    `,
);

export const CloseIconWrapper = styled.div`
    position: absolute;
    right: 16px;
    top: 24px;
`;
